/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiFrameSizeMinIcon32Regular = forwardRef('UiFrameSizeMinIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M20 3a1 1 0 0 1 1 1v5a2 2 0 0 0 2 2h5a1 1 0 1 1 0 2h-5a4 4 0 0 1-4-4V4a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M4 19a1 1 0 1 0 0 2h5a2 2 0 0 1 2 2v5a1 1 0 1 0 2 0v-5a4 4 0 0 0-4-4H4Z" }),
        React.createElement("path", { d: "M23 19a4 4 0 0 0-4 4v5a1 1 0 1 0 2 0v-5a2 2 0 0 1 2-2h5a1 1 0 1 0 0-2h-5Z" }),
        React.createElement("path", { d: "M13 4a1 1 0 1 0-2 0v5a2 2 0 0 1-2 2H4a1 1 0 1 0 0 2h5a4 4 0 0 0 4-4V4Z" })));
});
